export default __webpack_public_path__ + "static/media/recipe-placeholder.2e850a3a.png";